import { theme } from 'canoe';
import React from 'react';

export const LinkOpen = () => (
  <svg width={12} height={12} viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.22192 2.3654C4.25685 1.7436 4.77526 0.5 6.56954 0.5C8.36381 0.5 8.88225 1.7436 8.91718 2.3654V6.16709"
      stroke={theme.colors.OnyxGrayL40}
      strokeLinecap="square"
    />
    <path
      d="M8.91699 11.6346C8.88207 12.2564 8.36365 13.5 6.56938 13.5C4.77511 13.5 4.25667 12.2564 4.22173 11.6346V7.94624"
      stroke={theme.colors.OnyxGrayL40}
      strokeLinecap="square"
    />
    <path
      d="M0.963623 3.08789L12.1753 10.9668"
      stroke={theme.colors.OnyxGrayL40}
      strokeLinecap="square"
    />
  </svg>
);
